// extracted by mini-css-extract-plugin
export default {"root":"BlockCard_root__q7mND","appear":"BlockCard_appear__HxG2f","appearAnimation":"BlockCard_appearAnimation__MYyvI"};